import React from 'react';
import { PRICE } from '../data/salesContent';
export function PriceBlock({
  lead
}: {
  lead?: string;
}) {
  return <div className="text-center" data-id="element-41" data-mp="1yua0bo3nuprj">
      {lead && <p className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-400 md:text-base" data-id="element-42" data-mp="1yxo1wu4i2uxx">{lead}</p>}
      <p className="font-display mt-1 text-6xl font-black text-zinc-50 tabular-nums md:text-7xl" data-id="element-43" data-mp="2csqf82bofmkr">{PRICE}</p>
      <p className="mt-2 text-base text-zinc-400 md:text-lg" data-id="element-44" data-mp="1k6f6g4dx2fcv">Pago único · Acceso digital inmediato</p>
    </div>;
}